import * as React from 'react';
import { SVGProps } from 'react';

const IconPhoneSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.479 20.576a18.515 18.515 0 0 1-8.055-8.055l3.08-2.296a1 1 0 0 0 .375-1.032L9.6 3.77A1 1 0 0 0 8.625 3H4.222C3.55 3 3 3.55 3 4.222 3 15.7 12.301 25 23.778 25 24.45 25 25 24.45 25 23.778v-4.405a1 1 0 0 0-.768-.973l-5.423-1.29a1 1 0 0 0-1.034.377l-2.296 3.089Z" />
  </svg>
);
export default IconPhoneSizeL;
